import {createFileRoute} from '@tanstack/react-router';
import SpecialOfferPage from '@features/special-offer/page';

export const Route = createFileRoute('/special-offer')({
  component: SpecialOfferPage,
});
